<template>
  <s-modal
    class="criteria-modal"
    v-model="showModal"
    ok-only
    :title="title"
    @ok="closeModal"
  >
    <div class="criteria-modal__wrapper">
      <div class="criteria-modal__description-title">
        {{ $t('general.description') }}
      </div>
      <div class="criteria-modal__description">
        <span>{{ criteriaDescription }}</span>
        <span
          v-show="isTreetechMethodology"
          class="criteria-modal__link"
          @click="downloadPaper"
        >
          A Stairway Statistical Neural Model for DGA Analysis.
        </span>
      </div>
    </div>
  </s-modal>
</template>

<script>
import { CriteriaDuvalMethods } from 'sigma-mappings';
import parametersOfMethodsService from '@/domain/services/installation/engineering/chromatography/parametersOfMethods';

export default {
  name: 'CriteriaModal',
  props: {
    value: {
      type: Boolean,
    },
    entryCriteria: {
      type: String,
    },
    title: {
      type: String,
    },
  },
  computed: {
    showModal: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    isTreetechMethodology() {
      return this.entryCriteria === CriteriaDuvalMethods.TREETECH_METHODOLOGY;
    },
    criteriaDescription() {
      const descriptions = {
        [CriteriaDuvalMethods.ALWAYS]: this.$t('messages.MI019.message'),
        [CriteriaDuvalMethods.TREETECH_METHODOLOGY]: this.$t('messages.MI018.message'),
        [CriteriaDuvalMethods.BASED_ANOTHER_STANDARD_METHOD]: this.$t('messages.MI017.message'),
        [CriteriaDuvalMethods.GASES_LIMIT]: this.$t('messages.MI016.message'),
      };
      return descriptions[this.entryCriteria];
    },
  },
  methods: {
    closeModal() {
      this.showModal = false;
    },
    downloadPaper() {
      return parametersOfMethodsService.getTreetechMethodologyPaper();
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "src/styles/defaults/variables"

  .criteria-modal
    &__wrapper
      border: 1px solid $color-border-gray
      border-radius: 3px
    &__description-title
      background-color: var(--color-table-header-bg)
      height: 45px
      display: flex
      justify-content: center
      align-items: center
      font-weight: bold
    &__description
      overflow-y: scroll
      padding: 15px
      height: 215px
    &__link
      color: $color-link
      text-decoration: underline
      cursor: pointer
      display: inline-block
</style>
